// /*jshint esversion: 6 */
// (function($, Drupal) {

//   if (Drupal) {

//     // @TODO: reduce this

//     Drupal.behaviors.initEventsViewExposedFilters = {

//       attach: function (context, settings) {

//         $('.view-filters select', context)
//             .once('platform')
//             .select2({
//               dropdownAutoWidth: true,
//               minimumResultsForSearch: Infinity,
//               width: null,
//               containerCss: {
//                 background: 'transparent'
//               }
//             });

//         const picker = $('#js_form_event_form_date_range', context);
//         const monthPicker = $('#js_form_event_form_date_month', context);

//         let disabledDatesEnd = new Date();
//         let disabledDatesStart = new Date(-8640000000000000); // lol... effectively the beginning of time.
//         disabledDatesEnd.setDate(disabledDatesEnd.getDate() - 1); // yesterday
//         let container = document.querySelector('#event-date-filter-wrapper');
//         let monthContainer = document.querySelector('#event-month-filter-wrapper');
//         let monthFilterField = $('div.form-item-field-event-recur-date-occurrences-month input[name="field_event_recur_date_occurrences_month"]');
//         let dateFilterField = $('div.js-form-item-field-event-recur-date-occurrences input[name="field_event_recur_date_occurrences"]');
//         let categoryFilterField = $('div.form-item-field-event-type-target-id select[name="field_event_type_target_id"]');
//         let locationFilterField = $('div.js-form-item-gid select[name="gid"]');
//         let categoryFilterFieldFirst = $('div.form-item-field-event-type-target-id select[name="field_event_type_target_id"] option:first');
//         let locationFilterFieldFirst = $('div.js-form-item-gid select[name="gid"] option:first');
//         let termFilterField = $('div.js-form-item-title input[name="title"]');

//         // @todo location has a different value..
//         let locationFilterFieldSelected = $('div.js-form-item-gid select[name="gid"] option:selected');

//         let formContainer = $('.view-events-card-grid');
//         let form = formContainer.find('form.views-exposed-form');
//         let selectedItemsContainer = formContainer.find('.view-filter-selections > .container');

//         let dateVal = dateFilterField.val();
//         let monthDateVal = monthFilterField.val();
//         let dateEl = $('.js-form-date-range .select2-selection__rendered');
//         let categoryEl = $('.js-form-item-field-event-type-target-id .select2-selection__rendered');
//         let showfilter = false;

//         let typingTimer;                //timer identifier
//         let doneTypingInterval = 1100;  //time in ms (5 seconds)

//         // @todo: add abstraction here instead of duplication..
//         var fpm = picker.once('platform').flatpickr({
//           mode: 'single',
//           appendTo: monthContainer,
//           position: 'below',
//           clickOpens: false,
//           minDate: "today",
//           plugins: [
//             ShortcutButtonsPlugin({
//               button: {
//                 label: 'Clear',
//               },
//               onClick: (index, fpm) => {
//                 var beforeMonth = void 0;
//                 var beforeDate = void 0;
//                 beforeMonth = monthFilterField;
//                 beforeDate = dateFilterField;
//                 beforeMonth.val('');
//                 beforeDate.val('');
//                 var sDates = [];
//                 sDates.push(beforeMonth.val());
//                 fpm.setDate(sDates);
//                 fpm.clear();
//                 fpm.close();
//                 $('.views-exposed-form input[type="submit"]').click();
//               }
//             }),
//             ShortcutButtonsPlugin({
//               button: {
//                 label: 'I have a specific date in mind',
//               },
//               onClick: (index, fpm) => {
//                 var beforeDate = void 0;
//                 beforeDate = monthFilterField;
//                 beforeDate.val('');
//                 var sDates = [];
//                 sDates.push(beforeDate.val());
//                 fpm.setDate(sDates);
//                 fpm.clear();
//                 fpm.close();
//                 fp.open();
//                 var leftPos = $('#js_form_event_form_date_range').offset().left;
//                 if (typeof leftPos !== "undefined") {
//                   $('#event-date-filter-wrapper .flatpickr-calendar').css('left', leftPos + 'px'); // hack to get the calendar in the same position..
//                 }
//               }
//             }),
//             new monthSelectPlugin({
//               shorthand: true, //defaults to false
//               dateFormat: "m.y", //defaults to "F Y"
//               altFormat: "F Y", //defaults to "F Y"
//               theme: "dark" // defaults to "light"
//             })
//           ],
//           onReady: function (selectedDates, dateStr, instance) {
//             let leftPos = $('#js_form_event_form_date_range').offset().left;
//             if (typeof leftPos !== "undefined") {
//               $('#event-month-filter-wrapper .flatpickr-calendar').css('left', leftPos + 'px'); // hack to get the calendar in the same position..
//             }
//           },
//           onOpen: function (selectedDates, dateStr, instance) {
//             let selectedStart,
//                 selectedEnd,
//                 beforeDate,
//                 afterDate,
//                 d, n;

//             beforeDate = monthFilterField;

//             selectedStart = new Date(selectedDates[0]);

//             let sDates = [];
//             sDates.push(beforeDate.val());

//             instance.setDate(sDates);

//           },
//           onClose: function (selectedDates, dateStr, instance) {
//             let selectedStart,
//                 selectedEnd,
//                 beforeDate,
//                 afterDate,
//                 d, n;

//             selectedStart = monthFormatDate(selectedDates[0]);

//             if ((selectedStart != 'Invalid Date') && (selectedStart !== 'NaN-NaN-NaN') && (selectedStart !== 'NaN-NaN')) {
//               dateFilterField.val('');
//               monthFilterField.val(selectedStart);
//               $('.views-exposed-form input[type="submit"]').click();
//             }
//           },
//         });

//         var fp = monthPicker.once('platform1').flatpickr({
//           mode: 'single',
//           appendTo: container,
//           position: 'below',
//           clickOpens: false,
//           minDate: "today",
//           plugins: [
//             ShortcutButtonsPlugin({
//               button: {
//                 label: 'Clear',
//               },
//               onClick: (index, fp) => {
//                 var beforeMonth = void 0;
//                 var beforeDate = void 0;
//                 beforeMonth = monthFilterField;
//                 beforeDate = dateFilterField;
//                 beforeMonth.val('');
//                 beforeDate.val('');
//                 var sDates = [];
//                 sDates.push(beforeDate.val());
//                 fp.setDate(sDates);
//                 fp.clear();
//                 fp.close();
//                 $('.views-exposed-form input[type="submit"]').click();
//               }
//             }),
//             ShortcutButtonsPlugin({
//               button: {
//                 label: 'I\'d like to search by month',
//               },
//               onClick: (index, fp) => {
//                 var beforeDate = void 0;
//                 beforeDate = dateFilterField;
//                 beforeDate.val('');
//                 var sDates = [];
//                 sDates.push(beforeDate.val());
//                 fp.setDate(sDates);
//                 fp.clear();
//                 fp.close();
//                 fpm.open();
//                 var leftPos = $('#js_form_event_form_date_range').offset().left;
//                 if (typeof leftPos !== "undefined") {
//                   $('#event-month-filter-wrapper .flatpickr-calendar').css('left', leftPos + 'px'); // hack to get the calendar in the same position..
//                 }
//               }
//             })
//           ],
//           onReady: function (selectedDates, dateStr, instance) {
//             // disable past months..
//             var currentMonthInt = disabledDatesEnd.getMonth();
//             var monthOptions = $('.flatpickr-monthSelect-months span.flatpickr-monthSelect-month');
//             var monthStrArray = { 'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5, 'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11 };
//             if (monthOptions.length) {
//               monthOptions.each(function () {
//                 var thisMonth = $(this).text();
//                 var thisMonthIndex = monthStrArray[thisMonth];
//                 if (currentMonthInt == thisMonthIndex) {
//                   //$(this).css({ 'color': 'rgba(57,57,57,.1)', 'border-color': 'rgba(57,57,57,.1)', 'cursor': 'not-allowed', 'pointer-events': 'none' });
//                   $(this).removeClass('disabled');
//                 }
//               });
//             }
//             var leftPos = $('#js_form_event_form_date_range').offset().left;
//             if (typeof leftPos !== "undefined") {
//               $('#event-date-filter-wrapper .flatpickr-calendar').css('left', leftPos + 'px'); // hack to get the calendar in the same position..
//             }
//           },
//           onOpen: function (selectedDates, dateStr, instance) {
//             let selectedStart,
//                 selectedEnd,
//                 beforeDate,
//                 afterDate;

//             beforeDate = dateFilterField;

//             selectedStart = new Date(selectedDates[0]);

//             let sDates = [];
//             sDates.push(beforeDate.val());

//             instance.setDate(sDates);

//           },
//           onClose: function (selectedDates, dateStr, instance) {
//             let selectedStart,
//                 selectedEnd,
//                 beforeDate,
//                 afterDate;

//             selectedStart = formatDate(selectedDates[0]);

//             if ((selectedStart != 'Invalid Date') && (selectedStart !== 'NaN-NaN-NaN') && (selectedStart !== 'NaN-NaN')) {
//               dateFilterField.val(selectedStart);
//               monthFilterField.val('');
//               $('.views-exposed-form input[type="submit"]').click();
//             }
//           },
//         });

//         if ((typeof monthDateVal !== "undefined") && (monthDateVal !== '')) {
//           dateEl.text(dateToString(monthDateVal));
//           // add to selections bar
//           selectedItemsContainer.prepend("<div data-item-value=\"field_event_recur_date_occurrences_month\" class=\"selected-item filter-selection d-flex justify-content-center\"><span>" + dateToString(monthDateVal) + "</span></div>");
//           showfilter = true;
//         }

//         if ((typeof dateVal !== "undefined") && (dateVal !== '')) {
//           dateEl.text(dateToString(dateVal));
//           // add to selections bar
//           selectedItemsContainer.prepend("<div data-item-value=\"field_event_recur_date_occurrences\" class=\"selected-item filter-selection d-flex justify-content-center\"><span>" + dateToString(dateVal) + "</span></div>");
//           showfilter = true;
//         }

//         if (categoryFilterField.val() !== categoryFilterFieldFirst.val()) {
//           selectedItemsContainer.prepend("<div data-item-value=\"field_event_type_target_id\" class=\"selected-item filter-selection d-flex justify-content-center\"><span>" + categoryEl.text() + "</span></div>");
//           showfilter = true;
//         }

//         if (locationFilterField.val() !== locationFilterFieldFirst.val()) {
//           selectedItemsContainer.prepend("<div data-item-value=\"gid\" class=\"selected-item filter-selection d-flex justify-content-center\"><span>" + locationFilterFieldSelected.text() + "</span></div>");
//           showfilter = true;
//         }

//         if ($(termFilterField).val()) {
//           selectedItemsContainer.prepend("<div data-item-value=\"title\" class=\"selected-item filter-selection d-flex justify-content-center\"><span>" + termFilterField.val() + "</span></div>");
//           showfilter = true;
//         }

//         // show the selected filters if selections made
//         if (showfilter) {
//           $('.view-events-card-grid .view-filter-selections').show();
//         }

//         $('.js-form-item-field-event-type-target-id .form-select').change(function () {
//           $('.views-exposed-form input[type="submit"]').click();
//         });

//         $('.js-form-item-field-event-location-target-id .form-select').change(function () {
//           $('.views-exposed-form input[type="submit"]').click();
//         });

//         $('.js-form-item-gid .form-select').change(function () {
//           $('.views-exposed-form input[type="submit"]').click();
//         });

//         //on keyup, start the countdown
//         $('#views-exposed-form-events-card-grid-all .form-item-title .form-text').keyup(function () {
//           clearTimeout(typingTimer);
//           if ($('#views-exposed-form-events-card-grid-all .form-item-title .form-text').val()) {
//             typingTimer = setTimeout(function () {
//               $('.views-exposed-form input[type="submit"]').click();
//             }, doneTypingInterval);
//           }
//         });

//         $('#js_form_event_form_selection').on('click', function () {
//           if (fpm.open) {
//             fpm.open(); // open the month calendar by default
//           }
//         });

//         // bug with flatpicker when clicking the current momth..
//         $('.flatpickr-monthSelect-month.selected').on('click', function (e) {
//           e.preventDefault();
//           var d = new Date();
//           var selectedStart = monthFormatDate(d);
//           monthFilterField.val(selectedStart);
//           dateFilterField.val('');
//           $('.views-exposed-form input[type="submit"]').click();
//         });

//         // clear selections in selected filter bar

//         var clearSelection = selectedItemsContainer.find('div.filter-clear-custom');
//         clearSelection.on('click', function (e) {
//           e.preventDefault();
//           monthFilterField.val('');
//           dateFilterField.val('');
//           categoryFilterField.val('');
//           locationFilterField.val('');
//           termFilterField.val('');
//           form.find('input.form-submit').once().click();
//         });

//         var clearSingleSelection = selectedItemsContainer.find('div.filter-selection');
//         clearSingleSelection.on('click', function (e) {
//           e.preventDefault();
//           var selectedField = $(this).data('item-value');
//           if (form.find('input[name="' + selectedField + '"]').length) {
//             form.find('input[name="' + selectedField + '"]').val('');
//           } else if (form.find('select[name="' + selectedField + '"]').length) {
//             form.find('select[name="' + selectedField + '"]').val('');
//           }
//           form.find('input.form-submit').once().click();
//         });


//       }
//     };
//   }

// }(jQuery, Drupal));
"use strict";